import shallowEqual from './shallowEqual';
/**
 * 打造一个类似 react 的 useEffect 的玩意儿，不同的是你要每次都按需触发一下
 */
export function makeEffectStub(fn, isEqual = shallowEqual) {
  let lastData = undefined;
  let lastCleanupFn = undefined;
  const doCleanup = () => {
    lastData = undefined;
    if (typeof lastCleanupFn === 'function') lastCleanupFn();
    lastCleanupFn = undefined;
  };
  const effectStub = (data, ...meanlessExtraArgs) => {
    const changed = !lastData || !isEqual(data, lastData);
    if (changed) {
      doCleanup();
      lastData = data;
      lastCleanupFn = fn(data, ...meanlessExtraArgs);
    }
  };
  effectStub.cleanup = doCleanup;
  return effectStub;
}
//# sourceMappingURL=makeEffectStub.js.map
